import React from "react";
import * as L from "leaflet";
import { GridLayer } from "react-leaflet";

L.TileLayer.ZoomDependent = L.TileLayer.extend({
    initialize: function(options) {
        L.setOptions(this, options);
    },
    getTileUrl: function(coords) {
        let url = false;
        this.options.tileSets.forEach((tileSet, i) => {
            if (!url) {
                url = tileSet.url;
                return;
            }
            if (tileSet.zoom <= coords.z) {
                url = tileSet.url;
            }
        });
        this._url = url;//used internally in getTileUrl
        return L.TileLayer.prototype.getTileUrl.call(this, coords);
    },
    getAttribution: function() {
        return this.options.attribution;
    }
});
L.tileLayer.zoomDependent = function(opts) {
    return new L.TileLayer.ZoomDependent(opts);
};

class ZoomDependentTileLayer extends GridLayer {
    createLeafletElement(props) {
        this.leafletElement = new L.tileLayer.zoomDependent(props);
        return this.leafletElement;
    }

    updateLeafletElement(prevProps, nextProps) {
        const { opacity, zIndex } = nextProps;
        L.setOptions(this.leafletElement, nextProps);
        //NOTE: not sure if this is used/needed, but it was in an example...
        if ( opacity !== prevProps.opacity ) {
            this.leafletElement.setOpacity(opacity);
        }
        if ( zIndex !== prevProps.zIndex ) {
            this.leafletElement.setZIndex(zIndex);
        }
    }
}

export default ZoomDependentTileLayer;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/ZoomDependentTileLayer/index.js